"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContact = void 0;
require("isomorphic-fetch");
const get_base_url_1 = __importDefault(require("./get-base-url"));
const shorten_look_ups_1 = __importDefault(require("./shorten-look-ups"));
const fetch_data_1 = __importDefault(require("../utils/fetch-data"));
exports.getContact = (data) => {
    const body = shorten_look_ups_1.default(data);
    const url = `${get_base_url_1.default(data.dataResidency)}/contact`;
    return fetch_data_1.default(url, body)
        .then((res) => res.contactId)
        .catch((err) => Promise.reject(`Failed to get contact from session id ${data.sessionId}. ${err.message}`));
};
